/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_TitleInputs */

const en_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzrichtlinie`)
};

const fr_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const es_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const it_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla privacy`)
};

const nl_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacybeleid`)
};

const pl_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka prywatności`)
};

const fi_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuojakäytäntö`)
};

const da_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatlivspolitik`)
};

const sv_privacy_title = /** @type {(inputs: Privacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritetspolicy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacy_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_title = /** @type {((inputs?: Privacy_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_title(inputs)
	if (locale === "fr") return fr_privacy_title(inputs)
	if (locale === "es") return es_privacy_title(inputs)
	if (locale === "it") return it_privacy_title(inputs)
	if (locale === "nl") return nl_privacy_title(inputs)
	if (locale === "pl") return pl_privacy_title(inputs)
	if (locale === "fi") return fi_privacy_title(inputs)
	if (locale === "da") return da_privacy_title(inputs)
	if (locale === "sv") return sv_privacy_title(inputs)
	return en_privacy_title(inputs)
});